import type { IIdeaCard } from "./index";

/**
 * Heuristic row height for a lane card. Used as the virtual list estimate and
 * as a fallback until DOM measurement fills the cache for that index.
 */
export function estimateLaneCardHeight(
  card: IIdeaCard | undefined,
  usesImpactStatementSystem: boolean,
): number {
  if (!card || !card?.idea) return 110;

  let height = 90;
  if (card.idea.name && card.idea.name.length > 25) {
    height += 16;
  }
  if (card.idea.labels && card.idea.labels.length > 0) {
    height += 20;
  }
  if (!card.idea.isSubmitted) {
    height += 16;
  }
  if (card.idea.assessments && card.idea.assessments.length > 0) {
    height += 26;
  }

  const board = card.idea.projectManagement?.boards?.find(
    (b) => b.forId === card.idea.challenge,
  );
  if (board) {
    if (board.deadline) {
      height += 16;
    }
    if (board.reviewDate) {
      height += 16;
    }
  }

  if (card.impactData) {
    if (usesImpactStatementSystem) {
      height += 38;
    }
    const visibleImpacts = card.impactData.totalImpacts.filter(
      (impact) => impact.enabled && impact.isPinned,
    );
    height += Math.ceil(visibleImpacts.length / 2) * 28;
  }

  return height;
}
